import React from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        "Name": "Vaishali Saraswat",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "2023",
        "GuideName": "Prof. KSMS Raghavarao",
        "CoGuideName": " Dr. Trivikram Nallamilli",
        "BroadArea": "Downstream Processing of Bioactive Compounds with Health Benefits from Macroalgae.",
        "Email": "ch23d006@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Vaishali%20Saraswat.jpg"
    },
    {
        "Name": "R Urmila Raghava Panikkar",
        "NameLink": "#",
        "Degree": "Civil and Environmental Engineering",
        "Batch": "2023",
        "GuideName": " Dr. Roshan Srivastav",        
        "BroadArea": "Water Resources Management",
        "Email": "ce23d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Urmila%20Raghava%20Panikkar.jpg"
    },
    {
        "Name": "Amey Abhay Dukle",
        "NameLink": "#",
        "Degree": "Mechanical Engineering",
        "Batch": "2022",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "BroadArea": "Additive Manufacturing of Biomaterials",
        "Email": "me22d503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Dukle%20Amey%20Abhay.jpeg"
    },

    {
        "Name": "Vikrant Yadav",
        "NameLink": "#",
        "Degree": "Physics",
        "Batch": "2022",
        "GuideName": "Dr. Arijit Sharma",
        "BroadArea": "Experimental Atomic, Molecular and Optical Physics",
        "Email": "ph22d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Vikrant%20Yadav.jpg"
    },

    {
        "Name": "Vinith J",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "2022",
        "GuideName": "Dr. Uday Kumar. S",     
        "BroadArea": "Nano bio technology",
        "Email": "ch22d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Vinith%20J.jpg"
    },
    {
        "Name": "Pankaj Adhikary",
        "NameLink": "#",
        "Degree": "Chemistry",
        "Batch": "2022",
        "GuideName": "Dr. Rajib Biswas",    
        "BroadArea": "Theoretical and Computational Chemistry",
        "Email": "cy22d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Pankaj%20Adhikary.jpg"
    },



    {
        "Name": "R S Haripriya",
        "NameLink": "#",
        "Degree": "Electrical Engineering",
        "Batch": "Jan 2022",
        "GuideName": "Dr. Jaynarayan T Tudu",
        "CoGuideName": "Dr. Vikramkumar Pudi",
        "BroadArea": "VLSI Test and Verification",
        "Email": "ee22d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Haripriya_PMRF.JPG"
    },
    {
        "Name": "Spoorthy B M",
        "NameLink": "#",
        "Degree": "Civil and Environmental Engineering",
        "Batch": "2022",
        "GuideName": "Prof. B. Krishna Prapoorna",
        "CoGuideName": "Dr. P. Venkataraman",
        "BroadArea": "Composite Wastes in Pavement Applications",

        "Image": "https://files.iittp.ac.in/doc/pmrf/Spoorthy.jpg"
    },
    {
        "Name": "Tadavarthi Pushparaj Gandhi",
        "NameLink": "https://files.iittp.ac.in/doc/pmrf/T Pushparaj gandhi_website.pdf",
        "Degree": "Civil and Environmental Engineering",
        "Batch": "January 2022",
        "GuideName": "Dr. Shihabudheen M. Maliyekkal and Dr. Reetesh Kumar Gangwar",
        "BroadArea": "Development of a non-thermal atmospheric pressure plasma reactor for the treatment of food contaminated with mycotoxins",
        "Image": "https://files.iittp.ac.in/doc/pmrf/T Pushparaj Gandhi_Photo.jpg"
    },
    {
        "Name": "Annette Mariya Tedy",
        "NameLink": "#",
        "Degree": "Chemistry",
        "Batch": "2021",
        "GuideName": "Dr. Arun K Manna",
        "BroadArea": "Modelling organic luminescent molecules and materials",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Annette.jpg"
    },
    {
        "Name": "Vivek Gupta",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "2021",
        "GuideName": "Prof. KSMS Raghavarao, Co-guide- Dr. Trivikram Nallamilli",
        "BroadArea": "Design of bioreactor for the cultivation of Amaranthus hairy roots and downstream processing of betalains",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Vivek Gupta .jpg"
    },
    {
        "Name": "Prabhleen Kukreja",
        "NameLink": "#",
        "Degree": "Computer Science Engineering",
        "Batch": "2021",
        "GuideName": "Dr. V. Mahendran",
        "BroadArea": "ML for IoT",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Prabhleen.jpg"
    },
    {
        "Name": "A Eashaan Rao",
        "NameLink": "https://files.iittp.ac.in/doc/pmrf/A Eashaan Rao.pdf",
        "Degree": "Computer Science and Engineering",
        "Batch": "2021",
        "GuideName": "Dr. Sridhar Chimalakonda",
        "BroadArea": "Software Engineering",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Eashaan Rao_Photo.jpg"
    },
    {
        "Name": "Srihari C",
        "NameLink": "https://files.iittp.ac.in/doc/pmrf/Srihari C.pdf",
        "Degree": "Mechanical Engineering",
        "Batch": "2021",
        "GuideName": "Dr D V Kiran, Dr P S Sai Krishna",
        "BroadArea": "Smart manufacturing platform for hybrid tandem wire arc additive manufacturing process (TWAAM)",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Srihari C_Photo.jpg"
    },
    {
        "Name": "Harsha Gopalakrishnan",
        "NameLink": "https://files.iittp.ac.in/doc/pmrf/Harsha Gopalakrishnan.pdf",
        "Degree": "Mathematics & Statistics",
        "Batch": "2020",
        "GuideName": "Dr Srijanani Anurag Prasad",
        "BroadArea": "Fractals",
        "Image": "https://files.iittp.ac.in/doc/pmrf/Harsha gopalakrishnan.jpg"
    }
    // {
    //     "Name": "Mulla Mahaboob Basha",
    //     "NameLink": "https://files.iittp.ac.in/doc/me19d505.pdf",
    //     "Degree": "Mechanical Engineering",
    //     "Batch": "2019",
    //     "GuideName": "Prof. Mamilla Ravi Sankar",
    //     "BroadArea": "Chemical and electrochemical assisted finishing processes",
    //     "Email": "me19d505@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/me19d505.jpg"
    // }



]



function Main() {

    return (
        <>

            <Header />
            <Breadcrumb title="Home" subtitle="PMRF" />

            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    {/* <i className="fal fa-graduation-cap" /> Research Scholars */}
                                </h5>
                                <h2>Prime Minister's Research Fellowship (PMRF)</h2>
                            </div>
                        </div>
                        <p className='mb-3 line c-lineheight2'>The Prime Minister's Research Fellows (PMRF) Scheme has been designed for improving the quality of research in various higher educational institutions in the country. With attractive fellowships, the scheme seeks to attract the best talent into research thereby realizing the vision of development through innovation. The scheme was announced in the Budget 2018-19. The institutes which can offer PMRF include all the IITs, all the IISERs, Indian Institute of Science, Bengaluru and some of the top Central Universities/NITs that offer science and/or technology degrees. The candidates will be selected through a rigorous selection process and their performance will be reviewed suitably through a national convention. Kindly visit <Link classname='c-link' to="https://pmrf.in/" target="_blank" >https://pmrf.in </Link> for more details about PMRF. </p>
                        {/* <h4>Code for Broad Areas and Nodal Expert Committee </h4> */}

                        <h4 className='c-headline mt-5 mb-3'>Code for Broad Areas and Nodal Expert Committee </h4>

                        <Table bordered responsive className='mt-3'>
                            <thead>
                                <tr>
                                    <th>Discipline(s)</th>
                                    <th>Institute</th>
                                    <th>Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Civil Engineering, Earth Science, Architecture, Ocean and Naval Engg</td>
                                    <td>Indian Institute of Technology, Roorkee</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Mechanical Engineering, Aerospace Engineering, Design</td>
                                    <td>Indian Institute of Technology, Bombay</td>
                                    <td>2</td>
                                </tr>
                                <tr>
                                    <td>Electrical Engineering, Electronics Engineering</td>
                                    <td>Indian Institute of Technology, Madras</td>
                                    <td>3</td>
                                </tr>
                                <tr>
                                    <td>Computer Science & Engineering, Data Science, Mathematics</td>
                                    <td>Indian Institute of Science</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>Biomedical Engineering, Biological Sciences, Agricultural Sciences</td>
                                    <td>Indian Institute of Technology, Delhi</td>
                                    <td>5</td>
                                </tr>
                                <tr>
                                    <td>Chemical Engineering, Textile Engineering</td>
                                    <td>Indian Institute of Technology, Guwahati</td>
                                    <td>6</td>
                                </tr>
                                <tr>
                                    <td>Materials Science and Metallurgical Engineering, Mining Engineering</td>
                                    <td>Indian Institute of Technology, Kanpur</td>
                                    <td>7</td>
                                </tr>
                                <tr>
                                    <td>Physics</td>
                                    <td>Jawaharlal Nehru University</td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>Chemistry</td>
                                    <td>Banaras Hindu University</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>Interdisciplinary areas in Science and Engineering</td>
                                    <td>Indian Institute of Technology, Kharagpur</td>
                                    <td>10</td>
                                </tr>
                            </tbody>
                        </Table>

                        <h3 className='mb-4 c-headline mt-5 mb-3'>PMRF Team </h3>
                        <div className=''>

                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />The PMRF scheme at IIT Tirupati is currently managed by Professor Suresh Jain (PMRF coordinator) with the help of a committee. </li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />The Academic Section is responsible for approving the scholarships, and the administration of the scholarship is handled by the Accounts section</li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Heads of department decide on shortlisting students. The PMRF committee provides overall supervision but the technical matters are handled by the individual department Heads </li>

                        </div>

                        <div className='mt-3 line c-lineheight3'>
                            <h5>PMRF Guidelines: <Link className="c-link" to="https://files.iittp.ac.in/pdfs/PMRFGuidelines.pdf" target="_blank">View</Link><br /></h5>
                            <h5>PMRF Research Grant Guidelines: <Link className="c-link" to="https://files.iittp.ac.in/pdfs/pmrf/Guidelines for disbursal of PMRF Research Grant IITT.pdf" target="_blank">View</Link><br /></h5>

                        </div>

                    </div>
                    <h3 className='c-headline mt-5 mb-3'>Scholar Details </h3>

                    <div className="row mt-5">
                        {teachers.map((teacher, index) => (
                            <div key={teacher.Email} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="/team-single">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.NameLink}>{teacher.Name}</Link>
                                        </h4>
                                        <div className="text-dark c-lineheight2">
                                            <p>
                                                <i className="fal fa-graduation-cap me-2" />
                                                {teacher.Degree}
                                            </p>
                                            <p className="text-dark">Year of joining Ph.D programme : {teacher.Batch}</p>
                                            <p className="text-dark">Ph. D Advisor: {teacher.GuideName}</p>
                                            {teacher.CoGuideName && (
                                                <p className="text-dark">Ph.D Co-Advisor: {teacher.CoGuideName}</p>
                                            )}
                                            <p className="text-dark">Broad Area : {teacher.BroadArea}</p>
                                            {(teacher.Email !== undefined && teacher.Email !== "") && (
                                                <p className="text-dark">
                                                    <i className="fal fa-envelope me-1" />
                                                    Email : {teacher.Email}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main